export function priceFloat(num) {
  return Number(num).toFixed(2)
}

export function expression(str) {
  RongIMLib.RongIMEmoji.init();
  return RongIMLib.RongIMEmoji.symbolToEmoji(str)
}

// 日期字符串转换月日
export function timeDate(times) {
  var timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
  // var timestr = ""+timearr[0]+"/" + timearr[1] + "/" + timearr[2]
  console.log('timearr',timearr)
  var timestr = "" + timearr[1].split("")[1] + "月" + timearr[2] + "日\t"
  return timestr
}

// 日期字符串转换月日
export function timeDateStr(times) {
  var timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
  // var timestr = ""+timearr[0]+"/" + timearr[1] + "/" + timearr[2]
  // console.log('timear1',timearr[1])
  var timestr = "" + timearr[1] + "月" + timearr[2] + "日\t"
  return timestr
}

// 日期字符串转换月日
export function timeStr(times) {
  var timearr = times.replace(" ", ":").replace(/\:/g, "-").split("-");
  var timestr = "" + timearr[0] + "-" + timearr[1] + "-" + timearr[2] + " " + timearr[3] + ":" + timearr[4] + "\t"
  return timestr
}

// 字符串截取第一位
export function strName(text) {
  // console.log(text)
  var timestr = text.charAt(0) + '***';
  return timestr
}